import { get, put, post, patch } from "./api_helper"

const getRetailListPageDataApi = params => get("admin/rtw-sales/page", params)
const createRetailListApi = params => post("admin/rtw-sales", params)
const getRetailListSingleApi = ({id}) => get(`admin/rtw-sales/${id}`)
const updateRetailListApi = ({ params, id }) =>
  put(`admin/rtw-sales/${id}`, params)
const getRetailListProductListApi = () => get("admin/rtw-sales/product-list")
const getRetailListPaymentApi = () => get("admin/rtw-sales/payment-method")
const getRetailSalesCSV = params => get("admin/rtw-sales/csv", params)


export {
  getRetailListPageDataApi,
  createRetailListApi,
  updateRetailListApi,
  getRetailSalesCSV,
  getRetailListPaymentApi,
  getRetailListProductListApi,
  getRetailListSingleApi,
}
